import {Routes} from '@angular/router';
import {authGuard} from "@shared/services/security/auth.guard";
import {typeGuard} from "@shared/services/security/type-guard";
import {PageTypesEnum} from "@shared/services/router/page-types.enum";
import {DemoDashboardComponent} from "../../../pages/demo/dashboard/dashboard.component";
import {DemoPatientListComponent} from "../../../pages/demo/patient-list/patient-list.component";
// DemoAppointmentsPage import intentionally kept unused — see the deactivated 'demo/sessions'
// route below (UNIVAPLAT-2600, Epic UNIVAPLAT-2588).
// import {DemoAppointmentsPage} from "../../../pages/demo/appointments/appointments.page";
import {DemoPatientOverviewComponent} from "../../../pages/demo/patient-overview/patient-overview.component";
import {DemoPatientAddRecordComponent} from "../../../pages/demo/patient-add-record/patient-add-record.component";
import {PageStylesEnum} from "@shared/services/router/page-styles.enum";


export const demoRoutes: Routes = [
    {
        path: 'demo/dashboard',
        component: DemoDashboardComponent,
        canActivate: [authGuard, typeGuard],
        data: {type: PageTypesEnum.CDSS}
    },
    {
        path: 'demo/patient-list',
        component: DemoPatientListComponent,
        canActivate: [authGuard, typeGuard],
        data: {type: PageTypesEnum.CDSS}
    },
    {
        path: 'demo/patient-overview',
        component: DemoPatientOverviewComponent,
        canActivate: [authGuard, typeGuard],
        data: {type: PageTypesEnum.CDSS}
    },
    {
        path: 'demo/patient-add-record',
        component: DemoPatientAddRecordComponent,
        canActivate: [authGuard, typeGuard],
        data: {type: PageTypesEnum.CDSS, style: PageStylesEnum.YELLOW}
    },
    // UNIVAPLAT-2600 (Epic UNIVAPLAT-2588): 'demo/sessions' deactivated alongside 'cdss/sessions'
    // — kept in the repo for possible future reactivation.
    // {
    //     path: 'demo/sessions',
    //     component: DemoAppointmentsPage,
    //     canActivate: [authGuard, typeGuard],
    //     data: {type: PageTypesEnum.CDSS}
    // }
];
